export default __webpack_public_path__ + "static/media/Reports & Stats.7654d005.png";